import { render, staticRenderFns } from "./SocialGames.vue?vue&type=template&id=46a43373&scoped=true&lang=html"
import script from "./SocialGames.vue?vue&type=script&lang=js"
export * from "./SocialGames.vue?vue&type=script&lang=js"
import style0 from "./SocialGames.vue?vue&type=style&index=0&id=46a43373&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a43373",
  null
  
)

export default component.exports